import { createDataCollection as publicCreateDataCollection, getDataCollection as publicGetDataCollection, listDataCollections as publicListDataCollections, updateDataCollection as publicUpdateDataCollection, deleteDataCollection as publicDeleteDataCollection, } from './data-v2-data-collection-collections.public';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import { onDataCollectionClonedEvent as publicOnDataCollectionClonedEvent } from './data-v2-data-collection-collections.public';
import { onDataCollectionChangedEvent as publicOnDataCollectionChangedEvent } from './data-v2-data-collection-collections.public';
import { onDataCollectionCreated as publicOnDataCollectionCreated } from './data-v2-data-collection-collections.public';
import { onDataCollectionUpdated as publicOnDataCollectionUpdated } from './data-v2-data-collection-collections.public';
import { onDataCollectionDeleted as publicOnDataCollectionDeleted } from './data-v2-data-collection-collections.public';
export const createDataCollection = createRESTModule(publicCreateDataCollection);
export const getDataCollection = createRESTModule(publicGetDataCollection);
export const listDataCollections = createRESTModule(publicListDataCollections);
export const updateDataCollection = createRESTModule(publicUpdateDataCollection);
export const deleteDataCollection = createRESTModule(publicDeleteDataCollection);
export { publicOnDataCollectionClonedEvent };
/**
 * Event triggered when collection is cloned from other instance
 * CREATED event will be also triggered along with this action
 */
export const onDataCollectionClonedEvent = createEventModule(publicOnDataCollectionClonedEvent);
export { publicOnDataCollectionChangedEvent };
/**
 * Event triggered when collection is changed, describing some of changes
 * UPDATED event will be also triggered along with this action
 */
export const onDataCollectionChangedEvent = createEventModule(publicOnDataCollectionChangedEvent);
export { publicOnDataCollectionCreated };
/** */
export const onDataCollectionCreated = createEventModule(publicOnDataCollectionCreated);
export { publicOnDataCollectionUpdated };
/** */
export const onDataCollectionUpdated = createEventModule(publicOnDataCollectionUpdated);
export { publicOnDataCollectionDeleted };
/** */
export const onDataCollectionDeleted = createEventModule(publicOnDataCollectionDeleted);
export { CollectionType, Direction, DataOperation, CollectionOperation, Type, QueryOperator, FieldPluginType, Role, Status, Format, PluginType, PagingMode, AccessLevel, SortOrder, Order, IndexStatus, WebhookIdentityType, } from './data-v2-data-collection-collections.universal';
//# sourceMappingURL=data-v2-data-collection-collections.context.js.map